import axios from "axios";

export const fetchOrders = async (page, token, per_page) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/orders`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        page: page,
        per_page: per_page,
      },
    }
  );
  return data;
};

export const addOrder = async (token, orderData) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/orders`,
    orderData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};